import { useTranslation } from "react-i18next";
import Navbar from "../../../../components/navbar/navbar.component";
import { useContext, useEffect, useState } from "react";
import { Delete, Get, handleError } from "../../../../utils/fetch.util";
import { UserContext } from "../../../../contexts/user.context";
import {
  CompainesGrid,
  DashboardContainer,
} from "../companies/companies.styles";
import NoData from "../../../../components/noData/noData.component";
import ConfirmationModal from "../../../../components/modals/confirmationModal/confirmationModal.component";
import LoadingData from "../../../../components/loadingData/loadingData.component";
import BackButton from "../../../../components/modals/AddAssetModal/BackButton/BackButton";
import AppCard from "../../../../components/AppCard/AppCard.component";
import AddAppModal from "../../../../components/modals/AddAppModal/AddAppModal.component";
import EditAppModal from "../../../../components/modals/EditAppModal/EditAppModal.component";
import Footer from "../../../../components/Footer/Footer";

// import AppCard from "../../../../components/AppCard/AppCard.component";
// import AddAppModal from "../../../../components/modals/AddAppModal/AddAppModal.component";
// import EditAppModal from "../../../../components/modals/EditAppModal/EditAppModal.component";

export type AppsType = {
  id?: number;
  name: string;
  description: string;
  picture_url: string;
  leango_app_service_relationship: any[]
};

export default function Apps() {
  const [apps, setApps] = useState<AppsType[]>([]);
  const [originalApps, setOriginalApps] = useState<AppsType[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isAddAppModalOpen, setIsAddAppModalOpen] = useState<boolean>(false);
  const [isEditAppModalOpen, setIsEditAppModalOpen] = useState<boolean>(false);
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] =
    useState<boolean>(false);
  const [isFetching, setIsFetchingData] = useState<boolean>(true);
  const [appId, setAppId] = useState<number>(0);
  const { getValidToken } = useContext(UserContext);
  const { t } = useTranslation();

  const getAllApps = async () => {
    if (localStorage.getItem("user") !== "admin") return;
    const res = await Get("leango-apps/get-all-leango-apps", getValidToken());

    setApps(res.data);
    setOriginalApps(res.data);
    setIsFetchingData(false);
  };

  const deleteApp = async () => {
    setIsLoading(true);
    const res = await Delete(
      `leango-apps/get-all-leango-apps?leango_app_ids=[${Number(appId)}]`,
      getValidToken()
    );

    if (res.error || !res.data) {
      if (getValidToken()) handleError(res);
      setIsLoading(false);
      setIsConfirmationModalOpen(false);
      return;
    }

    getValidToken() && getAllApps();
    setIsLoading(false);
    setIsConfirmationModalOpen(false);
  };

  useEffect(() => {
    getValidToken() && getAllApps();
  }, []);

  const filterApps = (searchTerm: string) => {
    if (searchTerm.trim() === "") {
      // If searchTerm is empty, set Apps to the original array
      setApps(originalApps);
    } else {
      // If searchTerm is not empty, filter Apps based on the searchTerm
      const filteredApps = apps.filter((app: AppsType) => {
        return app?.name.toLowerCase().includes(searchTerm.toLowerCase());
      });
      setApps(filteredApps);
    }
  };

  if (isFetching) return <LoadingData style={{ height: "100vh" }} />;

  return (
    <>
      <DashboardContainer>
        <Navbar
          toggleModal={() => setIsAddAppModalOpen(true)}
          search={filterApps}
        />

        <BackButton position="mt-10 ml-10" />

        <h1 className="my-[3rem] text-black text-4xl text-center">
          {t("adminDashboard__apps")}
        </h1>

        <CompainesGrid>
          {apps?.map((app: AppsType) => (
            <AppCard
              toggleConfirmationModal={() => setIsConfirmationModalOpen(true)}
              toggleEditModal={() => setIsEditAppModalOpen(true)}
              {...app}
              setAppId={setAppId}
            />
          ))}
        </CompainesGrid>
        {apps?.length == 0 && <NoData message={t("no_apps")} />}

        <AddAppModal
          isOpen={isAddAppModalOpen}
          onClose={() => setIsAddAppModalOpen(false)}
          getAllApps={getAllApps}
        />
        <EditAppModal
          isOpen={isEditAppModalOpen}
          onClose={() => {
            setIsEditAppModalOpen(false);
            setAppId(0);
          }}
          AppId={appId}
          getAllApps={getAllApps}
        />
        <ConfirmationModal
          title={t("contract__delete_app")}
          message={t("confirm_delete")}
          isLoading={isLoading}
          onConfirm={deleteApp}
          closeConfirmationModal={() => setIsConfirmationModalOpen(false)}
          isShown={isConfirmationModalOpen}
          strict={true}
        />
      </DashboardContainer>
      <Footer />
    </>
  );
}
